export default class MaterialFixmethodsController {
  constructor(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
    "ngInject";
    this.ProductsDataProvider = ProductsDataProvider;
    this.ProductPartsDataProvider = ProductPartsDataProvider;

    let
      product = ProductsDataProvider.products.findOne({slug: $stateParams.product}),
      materials = product.materials,
      material = materials.find((material) => material.slug == $stateParams.material),
      productFixmethods = material.spec.fixmethods,
      allFixmethods = ProductPartsDataProvider.fixmethods.find({}).map((fixmethod) => Object.assign({}, fixmethod));


    allFixmethods.forEach((fixmethod) => {
      fixmethod.assigned = productFixmethods.some((productFixmethod) => fixmethod.id == productFixmethod.id);
    });
    this.fixmethods = allFixmethods;
    this.product = product;
    this.material = material;
    this.filterState = "assigned";
  }

  filter(fixmethods) {
    switch (this.filterState) {
      case 'assigned':
        return fixmethods.filter((fixmethod) => fixmethod.assigned == true);
      case 'unassigned':
        return fixmethods.filter((fixmethod) => fixmethod.assigned != true);
      case 'all':
        return fixmethods;
      default:
        throw new Error("unsupported filter type for fixmethods")
    }
  }

  setFilterState(value, $event) {
    if ($event) {
      $event.preventDefault();
    }
    this.filterState = value;
  }

  changeShapeAssigment(fixmethod, $event) {
    $event.preventDefault();
    fixmethod.__loading = true;
    let
      actionName = '';
    if (fixmethod.assigned) {
      actionName = 'deleteProductMaterialFixmethod'
    } else {
      actionName = 'addProductMaterialFixmethod';
    }
    this.ProductsDataProvider[actionName](
      this.product.id,
      this.material.id,
      fixmethod.id
    ).then((responseShape) => {
      delete fixmethod.__loading;
      fixmethod.assigned = !fixmethod.assigned;
    });
  }


}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-fixmethod-spec/controller.js
 **/